// react
import React from "react";

// third-party
import classNames from "classnames";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Link } from "react-router-dom";

// application
import AsyncAction from "./AsyncAction";
import Currency from "./Currency";
import Rating from "./Rating";
import { AddSquareBtnSvg } from "../../svg";
import { cartAddItem } from "../../store/cart";
import { compareAddItem } from "../../store/compare";
import { quickviewOpen } from "../../store/quickview";
import { allEqual, getNoImg, url, returnResponsiveImg } from "../../services/utils";
import { wishlistAddItem } from "../../store/wishlist";

function ProductCard(props) {
    const { product, layout, quickviewOpen, cartAddItem, wishlistAddItem, compareAddItem, design, noPrice, page, type, showAddCart } =
        props;
    const containerClasses = classNames("product-card " + (design ? design : ""), {
        "product-card--layout--grid product-card--size--sm": layout === "grid-sm",
        "product-card--layout--grid product-card--size--nl": layout === "grid-nl",
        "product-card--layout--grid product-card--size--lg": layout === "grid-lg",
        "product-card--layout--list": layout === "list",
        "product-card--layout--horizontal": layout === "horizontal",
    });

    function returnPath() {
        if (
            window.location.pathname == "/search-products" ||
            window.location.pathname.indexOf("/category/") > -1 ||
            window.location.pathname.indexOf("/brand/") > -1
        )
            return { pathname: "/product/" + product.slug, state: { location: window.location.pathname, page: page } };
        else return url.product(product);
    }

    let badges = [];
    let image;
    let price;
    let features;

    if (product.progression == "upcoming") {
        badges.push(
            <div key="new" className="product-card__badge product-card__badge--upcoming">
                Coming Soon
            </div>
        );
    } else if (product.progression == "history") {
        badges.push(
            <div key="new" className="product-card__badge product-card__badge--history">
                Not Available
            </div>
        );
    } else if (product.is_new) {
        badges.push(
            <div key="new" className="product-card__badge product-card__badge--new">
                New
            </div>
        );
    }

    badges = badges.length ? <div className="product-card__badges-list">{badges}</div> : null;

    image = (
        <div className="product-card__image product-image">
            <Link to={returnPath()} className="product-image__body">
                <img
                    className="product-image__img"
                    src={product.images && product.images[0] ? returnResponsiveImg(product.images[0]) : getNoImg()}
                    alt={product.slug}
                    onError={(e) => (e.target.src = getNoImg())}
                />
            </Link>
        </div>
    );

    price = (
        <div className="product-card__prices">
            {!product.is_sales && allEqual(product.price, "price") ? (
                <Currency value={product.price} />
            ) : product.is_sales && allEqual(product.sales_price, "price") ? (
                <>
                    <div className="product__new-price">
                        <Currency value={product.sales_price} />
                    </div>
                    {!allEqual([...product.sales_price, ...product.price], "price") ? (
                        <div className="product__old-price" style={{ fontSize: "inherit" }}>
                            <Currency value={product.price} />
                        </div>
                    ) : null}
                </>
            ) : product.is_sales ? (
                <>
                    <Currency value={product.sales_price[0]} /> {product.sales_price[product.sales_price.length - 1] ? " - " : null}{" "}
                    {product.sales_price[product.sales_price.length - 1] ? (
                        <Currency value={product.sales_price[product.sales_price.length - 1]} />
                    ) : null}
                </>
            ) : (
                <>
                    <Currency value={product.price[0]} /> {product.price[product.price.length - 1] ? " - " : null}{" "}
                    {product.price[product.price.length - 1] ? <Currency value={product.price[product.price.length - 1]} /> : null}
                </>
            )}
        </div>
    );

    return (
        <div id={"product-card-" + product.slug} className={containerClasses}>
            {/* <AsyncAction
                action={() => quickviewOpen(product.slug)}
                render={({ run, loading }) => (
                    <button
                        type="button"
                        onClick={run}
                        className={classNames('product-card__quickview', {
                            'product-card__quickview--preload': loading,
                        })}
                    >
                        <Quickview16Svg />
                    </button>
                )}
            /> */}
            {badges}
            {image}
            {/* <div className="product-card__body"> */}
            <div className="product-card__info">
                <div className={"product-card__name " + (design == "white-background" ? "text-black" : "")}>
                    <Link to={url.product(product)}>{product.name}</Link>
                </div>
                {/* <div className="product-card__rating">
                    <Rating value={product.rating} />
                    <div className=" product-card__rating-legend">{`${product.reviews} Reviews`}</div>
                </div> */}
                <div className="product-card__features-list">{product.short_description}</div>
            </div>
            <div className={"product-card__actions" + (type ? " " + type : "")}>
                {/* <div className="product-card__availability">
                    Availability:
                    <span className="text-success">In Stock</span>
                </div> */}
                {noPrice || product.enquiry_only == 1 ? <div className="product-card__prices" /> : price}

                <div className="product-card__buttons">
                    <button type="button" onClick={() => quickviewOpen(product)} className="btn btn-sm btn-primary product-card__addtocart">
                        Add To Cart
                    </button>
                    {/* <span onClick={() => quickviewOpen(product)} className="product-card__addtocart--icon">
                        <AddSquareBtnSvg />
                    </span> */}
                    <button
                        type="button"
                        onClick={() => quickviewOpen(product)}
                        className="btn btn-primary product-card__addtocart product-card__addtocart--list"
                    >
                        Add To Cart
                    </button>

                    {/* 
                    <AsyncAction
                        action={() => wishlistAddItem(product)}
                        render={({ run, loading }) => (
                            <button
                                type="button"
                                onClick={run}
                                className={classNames('btn btn-light btn-svg-icon btn-svg-icon--fake-svg product-card__wishlist', {
                                    'btn-loading': loading,
                                })}
                            >
                                <Wishlist16Svg />
                            </button>
                        )}
                    />
                    <AsyncAction
                        action={() => compareAddItem(product)}
                        render={({ run, loading }) => (
                            <button
                                type="button"
                                onClick={run}
                                className={classNames('btn btn-light btn-svg-icon btn-svg-icon--fake-svg product-card__compare', {
                                    'btn-loading': loading,
                                })}
                            >
                                <Compare16Svg />
                            </button>
                        )}
                    />
                </div> */}
                </div>
            </div>
        </div>
    );
}

ProductCard.propTypes = {
    /**
     * product object
     */
    product: PropTypes.object.isRequired,
    /**
     * product card layout
     * one of ['grid-sm', 'grid-nl', 'grid-lg', 'list', 'horizontal']
     */
    layout: PropTypes.oneOf(["grid-sm", "grid-nl", "grid-lg", "list", "horizontal"]),
};

const mapStateToProps = () => ({});

const mapDispatchToProps = {
    cartAddItem,
    wishlistAddItem,
    compareAddItem,
    quickviewOpen,
};

export default connect(mapStateToProps, mapDispatchToProps)(ProductCard);
